/**
 * Преобразует мета-описание полей в словарь подписей `{ field: label }`.
 */
export function toFieldLabels(fieldsMeta) {
  return Object.fromEntries(Object.entries(fieldsMeta).map(([field, meta]) => [field, meta.label]))
}

/**
 * Возвращает нужный formatter для одного поля на основе `valueType`.
 * `resolvers` содержит реализации для relation/date/bool/configIdList.
 */
export function modelFieldValueFormatter(modelPath, meta, resolvers) {
  if (meta.valueType === 'relation') {
    if (meta.configPath && typeof resolvers.relationConfig === 'function') {
      return resolvers.relationConfig(meta.configPath)
    }
    return resolvers.relation
  }
  if (meta.valueType === 'date') {
    return resolvers.date
  }
  if (meta.valueType === 'bool') {
    return resolvers.bool
  }
  if (meta.valueType === 'configIdList') {
    return resolvers.configIdList(`${modelPath}.${meta.field}`)
  }
  if (meta.valueType === 'poEntries' && typeof resolvers.poEntries === 'function') {
    return resolvers.poEntries
  }
  if (meta.valueType === 'packBlocks' && typeof resolvers.packBlocks === 'function') {
    return resolvers.packBlocks
  }
  return null
}

/**
 * Собирает словарь formatter-ов `{ field: formatter }` для модели.
 * Поля без поддерживаемого `valueType` пропускаются.
 */
export function buildModelValueFormatters(modelPath, fieldsMeta, resolvers) {
  return Object.fromEntries(
    Object.entries(fieldsMeta)
      .map(([field, rawMeta]) => {
        const meta = { ...rawMeta, field }
        const formatter = modelFieldValueFormatter(modelPath, meta, resolvers)
        return formatter ? [field, formatter] : null
      })
      .filter(Boolean)
  )
}

/**
 * Собирает словари labels по секциям:
 * `{ ModelName: { field: label } }`.
 */
export function buildModelLabelsBySection(sectionModelFields) {
  return Object.fromEntries(
    Object.entries(sectionModelFields).map(([modelName, cfg]) => [modelName, toFieldLabels(cfg.fields)])
  )
}

/**
 * Собирает formatter-ы по секциям (главная функция):
 * `{ ModelName: { field: formatter } }`.
 */
export function buildModelValueFormattersBySection(sectionModelFields, resolvers) {
  return Object.fromEntries(
    Object.entries(sectionModelFields).map(([modelName, cfg]) => [
      modelName,
      buildModelValueFormatters(cfg.modelPath, cfg.fields, resolvers),
    ])
  )
}
